export function validatePasswordStrength(password: string): {
  isValid: boolean;
  message?: string;
} {
  if (!password) {
    return {
      isValid: false,
      message: 'Password cannot be empty'
    };
  }

  if (password.length < 6) {
    return {
      isValid: false,
      message: 'Password must be at least 6 characters long'
    };
  }

  return {
    isValid: true
  };
}

export function logPasswordChange(success: boolean, message?: string) {
  if (success) {
    console.log('[Password Manager] Success:', message);
  } else {
    console.error('[Password Manager] Error:', message);
  }
}

export function clearPasswordStorage() {
  try {
    localStorage.removeItem('app-password');
    localStorage.removeItem('app-password-direct');
    return true;
  } catch (error) {
    console.error('Failed to clear password storage:', error);
    return false;
  }
}

export function migratePasswordData() {
  try {
    const oldPassword = localStorage.getItem('app-password');
    if (oldPassword) {
      localStorage.setItem('app-password-direct', oldPassword);
      localStorage.removeItem('app-password');
    }
    return true;
  } catch (error) {
    console.error('Failed to migrate password data:', error);
    return false;
  }
}